const SCREENS = {
  EMAIL_PASSWORD: "EMAIL_PASSWORD",
  FINISH_PROFILE: "FINISH_PROFILE",
  CREATE_COMMUNITY: "CREATE_COMMUNITY",
}

export default SCREENS
